<template>
  <div class="mental-health-participant-list">
    <slot v-if="data.length == 0" name="empty">
      <empty-state />
    </slot>
    <div v-else class="px-3">
      <c-input
        type="search"
        v-model="keyword"
        :placeholder="searchPlaceholder"
      />
      <p v-if="filteredData.length == 0" class="text-gray" align="center">
        Tidak ada data dengan kata kunci yang dicari.
      </p>
    </div>
    <div
      v-for="(checkup, index) in filteredData"
      :key="checkup.id"
      class="pointer"
      @click="onItemClick(checkup)"
    >
      <div class="px-3 py-2">
        <p class="mb-3">{{ checkup.problem.substr(0, 100) }}...</p>
        <div class="d-flex align-items-center flex-wrap">
          <span
            v-if="showName"
            class="badge badge-primary flex-shrink-0 d-inline-flex align-items-center mb-1 mr-1"
          >
            <material-icon
              name="person"
              type="rounded"
              size="12"
              class="mr-1"
            />
            {{ checkup.user.fullname }}
          </span>
          <span
            v-if="showStatusBadge"
            class="badge mr-1 mb-1"
            :class="getCheckupBadge(checkup.status)"
          >
            {{ capitalize(getCheckupStatusIndo(checkup.status)) }}
          </span>
          <span
            v-if="checkup.status == 'unscheduled'"
            class="badge flex-shrink-0 d-inline-flex align-items-center mb-1 text-gray"
          >
            <material-icon name="today" type="rounded" size="12" class="mr-1" />
            {{
              getScheduleOptionText(
                checkup.schedule.day,
                checkup.schedule.time_start,
                checkup.schedule.time_end
              )
            }}
          </span>
          <template v-else-if="checkup.status != 'canceled'">
            <span
              class="badge flex-shrink-0 d-inline-flex align-items-center mr-1 mb-1 text-gray"
            >
              <material-icon
                name="event"
                type="rounded"
                size="12"
                class="mr-1"
              />
              {{ formatDateForHuman(checkup.scheduled_at, true) }}
            </span>
            <span
              class="badge flex-shrink-0 d-inline-flex align-items-center mr-1 mb-1 text-gray"
            >
              <material-icon
                name="schedule"
                type="rounded"
                size="12"
                class="mr-1"
              />
              {{ formatTimeToIndo(checkup.schedule.time_start) }} -
              {{ formatTimeToIndo(checkup.schedule.time_end) }} WIB
            </span>
            <span
              class="badge flex-shrink-0 d-inline-flex align-items-center mb-1 text-gray"
            >
              <material-icon
                name="chair"
                type="outlined"
                size="12"
                class="mr-1"
              />
              {{ checkup.room.name }}
            </span>
          </template>
        </div>
      </div>
      <div v-if="index != filteredData.length - 1" class="divider"></div>
    </div>
  </div>
</template>

<script>
import {
  getScheduleOptionText,
  getCheckupStatusIndo,
  getCheckupBadge,
} from "@/helpers/mental-health";
import { debounce } from "@/helpers/common";

export default {
  name: "mental-health-participant-list",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    showName: {
      type: Boolean,
    },
    showStatusBadge: {
      type: Boolean,
    },
    searchPlaceholder: {
      type: String,
      default: "Cari...",
    },
  },
  data: function () {
    return {
      keyword: "",
      debouncedKeyword: "",
    };
  },
  watch: {
    keyword: debounce(function (newVal) {
      this.debouncedKeyword = newVal;
    }, 500),
  },
  computed: {
    filteredData: function () {
      const q = this.debouncedKeyword.toLowerCase();
      if (q.length > 0) {
        return this.data.filter((d) => {
          return (
            d.user?.fullname.toLowerCase().includes(q) ||
            d.problem.toLowerCase().includes(q)
          );
        });
      }
      return this.data;
    },
  },
  methods: {
    getCheckupStatusIndo,
    getScheduleOptionText,
    getCheckupBadge,
    onItemClick: function (checkup) {
      this.$emit("item-click", checkup);
    },
  },
};
</script>
